import ProgressBar from './component'
export default ProgressBar
